module.exports = __webpack_public_path__ + "img/teppich6.c807bdcb.png";